"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commercetoolsForkedFetch = exports.commercetoolsFetch = void 0;
const browser_monads_1 = require("browser-monads");
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const monet_1 = require("monet");
const perimeterX_1 = __importDefault(require("../perimeterX"));
const fluture_utils_1 = require("../utils/fluture-utils");
/**
 * Wraps a request to commercetools into a fetch request and returns a forked future.
 */
const commercetoolsFetch = (request) => {
    const requestOptions = {
        body: request.body,
        headers: request.headers,
        method: request.method
    };
    const baseHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    //addUserAgent applies the User-Agent header to GET requests when the window object does not exist. IE during builds
    // eslint-disable-next-line
    const addUserAgent = ((0, browser_monads_1.exists)(browser_monads_1.window) === false);
    const fetchOptions = request.method === 'GET'
        ? {
            ...requestOptions,
            headers: addUserAgent
                ? {
                    ...baseHeaders,
                    ...requestOptions.headers,
                    'User-Agent': 'SimpliSafe Frontend Node'
                }
                : {
                    ...baseHeaders,
                    ...requestOptions.headers
                }
        }
        : {
            ...requestOptions,
            headers: {
                ...baseHeaders,
                ...requestOptions.headers
            }
        };
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${request.endpoint}`, fetchOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody))
        .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull))
        .pipe((0, fluture_1.chainRej)(perimeterX_1.default));
};
exports.commercetoolsFetch = commercetoolsFetch;
const commercetoolsForkedFetch = (request) => (handleFailure) => (handleSuccess) => {
    (0, exports.commercetoolsFetch)(request)
        .pipe((0, fluture_1.fork)(handleFailure)(handleSuccess));
};
exports.commercetoolsForkedFetch = commercetoolsForkedFetch;
//# sourceMappingURL=commercetoolsClient.js.map